module.exports = __webpack_public_path__ + "static/media/new_front_smiling.a6937fa9.png";